import { tv } from 'tailwind-variants';

export const pageMenuStyles = tv({
  slots: {
    container: `
      border-line flex w-full flex-1 gap-4
    `,
    item: `
      text-fg-muted hover:border-fg hover:text-fg flex cursor-pointer items-center gap-4 border-b-2 border-transparent px-4 py-2
    `,
  },
  variants: {
    active: {
      true: {},
    },
  },
  compoundVariants: [
    {
      active: true,
      class: {
        item: 'border-primary! text-primary!',
      },
    },
  ],
});
